import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetClientOrders =
  ({
    callback,
    page,
    rowsPerPage,
    search,
    fetchAll,
    clientId,
    clientEmail,
    courseId,
  }) =>
    async (dispatch, getState) => {
      try {
        const params = new URLSearchParams();
        params.set("page", search || fetchAll ? 0 : page);
        params.set("limit", search || fetchAll ? 1000 : rowsPerPage);
        if (search) params.set("search", search);
        if (clientId) params.set("client_id", clientId);
        if (clientEmail) params.set("client_email", clientEmail);
        if (courseId) params.set("course_id", courseId);
        const query = "?" + params.toString();
        let link = UrlApi.client_orders.get + query;

        const response = await GetFunction({
          data: {},
          Route: link,
          showalert: false,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
          usersRoute: true,
        });
        callback(response);
      } catch (err) {
        callback(false);
      }
    };

export const GetClientOrderEmails =
  ({ callback }) =>
    async (dispatch, getState) => {
      try {
        const response = await GetFunction({
          data: {},
          Route: UrlApi.client_orders.get_emails,
          showalert: false,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
          usersRoute: true,
        });
        callback(response);
      } catch (err) {
        callback(false);
      }
    };

export const DeleteClientOrders =
  ({ mediaTypeId, callback }) =>
    async (dispatch, getState) => {
      try {
        let link = UrlApi.client_orders.delete;
        const response = await GetFunction({
          data: {},
          Route: link + `/${mediaTypeId}`,
          showalert: false,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
          usersRoute: true,
        });
        callback(response);
      } catch (err) {
        callback(false);
      }
    };

